exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * Copyright (c) 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */.dv-vorleistungen-list .rowHeader-berechtigterBetrag,.dv-vorleistungen-list .rowHeader-betrag,.dv-vorleistungen-list .rowHeader-empty1,.dv-vorleistungen-list .rowHeader-empty2{width:15%}.dv-vorleistungen-list .rowHeader-actions{width:130px}.dv-vorleistungen-list .rowBody-actions{text-align:center}.dv-vorleistungen-list .rowBody-actions button{width:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/app/core/component/dv-vorleistungen-list/dv-vorleistungen-list.scss
// module id = stLe
// module chunks = 0